// React and Router
import React, { Fragment } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

// Layouts
import DefaultLayout from './layout/DefaultLayout'

// Auth Pages
import Login from './pages/Auth/Login'
import Signup from './pages/Auth/Signup'
import ForgetPassword from './pages/Auth/ForgetPassword'
import ResetPassword from './pages/Auth/Resetpassword'

// Components
import PublicRoute from './components/Custom/CustomRoutes/PublicRoute'
import PrivateRoute from './components/Custom/CustomRoutes/PrivateRoute'
import NotFound from './pages/Auth/NotFound'

// Navigation
import AllRoutes from './navigation'

const App = () => {
  const filteredRoutes = AllRoutes() // Call function to get filtered routes

  return (
    <Fragment>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<PublicRoute />}>
            <Route path='/signup' element={<Signup />} />
            <Route path='/login' element={<Login />} />
            <Route path='/forget-password' element={<ForgetPassword />} />
            <Route path='/reset-password' element={<ResetPassword />} />
          </Route>

          {/* Private Routes */}
          <Route element={<PrivateRoute />}>
            <Route element={<DefaultLayout />}>
              {filteredRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
            </Route>
          </Route>

          {/* Not Found Route */}
          <Route path='/*' element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </Fragment>
  )
}

export default App
